module.exports = __webpack_public_path__ + "img/logo.ff931c98.png";